<template>
  <div class="user-cards-container" :class="{ 'is-IE': isIE11 }">
    <collect-pin v-if="showPinProjectView" class="collect-pin" :project="project" :pinSize="125"></collect-pin>
    <div v-if="!edit">
      <div @mousedown="move('up')" :class="{'hidden': !showUp}" class="button-container">
        <div><i class="fal fa-chevron-up fa"></i></div>
      </div>
      <div ref="cardsContainer" class="user-cards"
           :class="{'user-cards_auditorium': this.isAuditoriumStory}"
           @scroll="handleScroll">
        <div ref="cardItemContainer" class="card-item-container">
          <div v-if="projectQRLink" class="user-card" :class="{ 'is-IE': isIE11 }">
            <div class="user-header text-center">
              <p class="text-center">PROJECT QR CODE</p>
              <img id="QRCode" :src="projectQRLink" width="100%">
            </div>
            <div v-if="showPrintButton"><button @click="printQrCode(projectQRLink)" class="button is-primary is-small">Print for Booth</button></div>
          </div>
          <user-card v-for="user in this.members" :user="user" :key="user.name"></user-card>
        </div>
      </div>
      <div :class="{'hidden': !showDown}" @mousedown="move('down')" class="button-container down-button">
        <div><i class="fal fa-chevron-down fa"></i></div>
      </div>
    </div>
  </div>
</template>

<script>

import UserCard from './UserCard'

import auth from '@/libs/auth'

import CollectPin from '@/components/Controls/CollectPin'

import userAgent from '@/libs/user-agent'

export default {
  components: {
    UserCard,
    CollectPin
  },
  props: ['project', 'edit', 'showPinProjectView', 'projectQRLink'],
  mixins: [],
  data: function () {
    return {
      members: [],
      scrollPosition: 0,
      hasScrolledToBottom: false,
      scrollStarted: false,
      showUp: false,
      showDown: false,
      qrCodeUrl: ''
    }
  },
  watch: {
    project: function () {
      this.fetchMembers()
    }
  },
  created () {
    window.addEventListener('resize', this.getHeight)
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  mounted: function () {
    this.fetchMembers()
    const checkHeight = () => { this.getHeight() }
    const resizeObserver = new ResizeObserver(function () {
      checkHeight()
    })
    resizeObserver.observe(this.$refs.cardItemContainer)
  },

  computed: {
    isIE11: function () {
      return userAgent.isIE11()
    },
    isAuditoriumStory: function () {
      return this.$route.path.includes('auditoriumStory')
    },
    showPrintButton: function () {
      if (auth.isAdmin()) {
        return true
      }

      return this.loggedIn && this.projectMembers.some(m => m.user?.id === this.currentUser?.id)
    },
    projectMembers: function () {
      return this.$store.getters.projectMembers(this.project.id) ?? []
    },
    loggedIn: function () {
      return this.$store.getters.loggedIn
    },
    currentUser: function () {
      return this.$store.getters.currentUser ? this.$store.getters.currentUser : {}
    }
  },
  methods: {
    getHeight: function () {
      this.showDown = this.$refs.cardItemContainer.clientHeight > this.$refs.cardsContainer.clientHeight
    },
    projectIsApprove: function () {
      return this.project && this.project.status === 'approved'
    },
    fetchMembers: function () {
      if (!this.project || !this.project.id) {
        return
      }
      this.$store.dispatch('getMembers', { project: this.project, limit: 10, offset: 0 }).then((response) => {
        this.members.push.apply(this.members, response.members)
        this.filterMembers()
        this.getHeight()
      })
    },
    filterMembers: function () {
      if (this.$isOhioScience) {
        this.members = this.members.map(function (users) {
          if (users.role === 'owner') {
            return users.user
          }
        })
      } else {
        this.members = this.members.map(function (users) {
          if (users.role === 'co-owner' || users.role === 'owner') {
            return users.user
          }
        })
      }
      this.members = this.members.filter(function (users) {
        if (users !== undefined) {
          return users
        }
      })
    },
    move: function (value) {
      if (value === 'down') {
        this.scrollPosition = this.scrollPosition + 250
      }
      if (value === 'up') {
        this.scrollPosition = this.scrollPosition - 250
      }
      if (this.scrollPosition < 0) {
        this.scrollPosition = 0
      }
      this.$refs.cardsContainer.scrollTop = this.scrollPosition
    },
    handleScroll: function (el) {
      if (el.srcElement.scrollTop > 1) {
        this.showUp = true
      } else {
        this.showUp = false
      }
      if ((el.srcElement.offsetHeight + el.srcElement.scrollTop) >= el.srcElement.scrollHeight) {
        this.showDown = false
      } else {
        this.showDown = true
      }
    },
    printQrCode: function (url) {
      // Get HTML to print from element
      const WinPrint = window.open('', '', 'left=500,top=150,width=500,height=500,toolbar=0,scrollbars=0,status=0')
      WinPrint.document.write(`
        <!DOCTYPE html>
        <html>
          <body>
            <img src="` + url + `" width="100%">
          </body>
        </html>`)
      setTimeout(() => {
        WinPrint.focus()
        WinPrint.print()
        WinPrint.close()
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';

.user-cards-container {
  margin-left: 1rem;
}
@media only screen and (max-width: 767px) {
  .user-cards-container {
    top: 0px;
    left: 0px;
    position: relative;
    margin-left: 0px;
  }
  .user-cards-container.is-hidden-touch {
    display: block !important;
  }
  .card-item-container {
    display: flex;
    flex-wrap: wrap;
    height:auto;
  }
  .user-cards {
    height: auto !important;
    display: flex;
    flex-wrap: wrap;
    .user-card {
      width: calc(50% - 20px);
      flex: 0 0 calc(50% - 20px);
      margin-left: 10px;
      margin-right: 10px;
      .user-header {
        width: 100%;
        max-width: 70px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}
.collect-pin {
  display: flex;
  justify-content: space-around;
  margin: 1.25rem auto 0;
}

button {
  width: 100%;
  height: 2.5em;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  text-transform: uppercase;
  color: $primary;
i {
  font-size: 1rem;
}
}

@media only screen and (min-width: 767px) {
  .user-cards {
    max-height: calc(100vh - 150px);
  }
}

.user-cards {
  overflow: hidden;
  scroll-behavior: smooth;
.user-card {
.user-header {
  text-align: center;
p {
  margin-bottom: 12px;
}
}
}

&_auditorium {
   overflow-y: hidden;
   overflow-x: unset;
 }
}

.is-IE {
  right: calc(100vw/2 - 400px - 200px - 16px);
}

.scroll-button {
  height: 100%;
  width: 2rem;
  pointer-events: auto;
  align-items: center;
  justify-content: center;
  background-color: black;
  padding: 0.6rem 0.1rem;
  position: absolute;
  opacity: 0.4;
  transition: 0.2s;
&:hover {
   opacity: 0.7;
 }
}

.button-container {
  display: flex;
  justify-content: center;
  background: black;
  opacity: 0.4;
i {
  color: white;
}
&:hover {
   opacity: 0.7;
 }
}

.hidden {
  display: none;
}

.user-card {
  width: 215px;
  font-size: 0.8rem;
  z-index: 10;
  background-color: white;
  padding: 1rem;
  color: #4A4A4A;
  margin-bottom: 1rem;

  @media only screen
  and (max-height: 430px)
  and (orientation: landscape) {
    background-color: transparent !important;
    margin-top: .25rem;
    margin-left: -1.1rem;
  }

  .button {
    width: 100%;
    font-weight: 700;
    color: white;
    border: 1px solid $primary;
    &:hover {
      color: white;
      border-color: $link-hover;
      background-color: $link-hover;
    }
  }
}

</style>
